import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/rich/github/remapgl/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from "docz";
import Layer from "./layer";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "layer"
    }}>{`Layer`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`<Layer/>`}</inlineCode>{` component is a child of `}<a parentName="p" {...{
        "href": "/remapgl/docs/map"
      }}>{`Map`}</a>{`, it causes a layer to be added to a map. Layers are not DOM objects, they are rendered by the Map in its presentation layer, for example a canvas element.`}</p>
    <p>{`The order that layers appear in a Map are controlled by their order as children of a `}<inlineCode parentName="p">{`<Map/>`}</inlineCode>{`. As in an HTML document the last Layer in a `}<inlineCode parentName="p">{`<Map/>`}</inlineCode>{` component will be the top Layer in the Map.`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Layer} mdxType="Props" />
    <h2 {...{
      "id": "associated-types"
    }}>{`Associated types`}</h2>
    <h3 {...{
      "id": "expression"
    }}>{`Expression`}</h3>
    <p>{`Please see the `}<a parentName="p" {...{
        "href": "https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions"
      }}>{`MapboxGL documentation for expressions`}</a>{`.`}</p>
    <h3 {...{
      "id": "layout"
    }}>{`Layout`}</h3>
    <p>{`Please see the `}<a parentName="p" {...{
        "href": "https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers"
      }}>{`MapboxGL documentation for layers`}</a>{`.`}</p>
    <h3 {...{
      "id": "paint"
    }}>{`Paint`}</h3>
    <p>{`Please see the `}<a parentName="p" {...{
        "href": "https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers"
      }}>{`MapboxGL documentation for layers`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      